import React, { Component } from 'react'
import './AddCouponItems.css'
import { motion } from 'framer-motion'
import { backdropTransition, popupTransition, transitionDuration } from '../../../../../../Util/PageTransitions'
import Checkbox from '../../../../../../Util/Checkbox/Checkbox'

export default class AddCouponItems extends Component {

    constructor() {
        super()
        this.state = {
            itemsSelected: [],
            menuContainerHeight: 0
        }
    }

    componentDidMount() {
        let menu = []
        this.props.menu.forEach((section, sectionIndex) => {
            menu.push({id: section.id, items: section.menuItem.map((item, itemIndex) => {
                if (this.props.itemsRequiredForCoupon.some((itemRequired) => {
                    if (itemRequired.type === 'item') {
                        return itemRequired.selectedItemId === item.id && itemRequired.selectedSectionId === section.id && itemRequired.selected
                    } else {
                        return itemRequired.selectedSectionId === section.id && itemRequired.selected
                    }
                })) {
                    return true
                } else {
                    return false
                }
            })})
        })
        
        this.setState({itemsSelected: menu}, () => {
            const menuContainerHeight = document.getElementById('menuContainer').scrollHeight
            this.setState({menuContainerHeight})
        })
    }

    updateSectionSelectedHandler = (sectionIndex) => {
        let itemsSelected = this.state.itemsSelected
        if (itemsSelected[sectionIndex].items.every((value) => value)) {
            for (let i = 0; i < itemsSelected[sectionIndex].items.length; ++i) {
                itemsSelected[sectionIndex].items[i] = false
            }
        } else {
            for (let i = 0; i < itemsSelected[sectionIndex].items.length; ++i) {
                itemsSelected[sectionIndex].items[i] = true
            }
        }
        this.setState({itemsSelected})
    }

    updateItemHandler = (sectionIndex, itemIndex) => {
        let itemsSelected = this.state.itemsSelected
        itemsSelected[sectionIndex].items[itemIndex] = !itemsSelected[sectionIndex].items[itemIndex]
        this.setState({itemsSelected})
    }

    saveAndCloseHandler = () => {
        let itemsRequired = []
        let itemsSelected = this.state.itemsSelected
        itemsSelected.forEach((section, sectionIndex) => {
            if (section.items.every((value) => value)) {
                itemsRequired.push({selected: true, selectedSectionId: this.props.menu[sectionIndex].id, selectedItemId: 0, type: 'section'})
            } else {
                section.items.forEach((item, itemIndex) => {
                    if (item) {
                        itemsRequired.push({selected: true, selectedSectionId: this.props.menu[sectionIndex].id, selectedItemId: this.props.menu[sectionIndex].menuItem[itemIndex].id, type: 'item'})
                    }
                })
            }
        })

        this.props.addItemsToCouponCallback(itemsRequired)
        this.props.closeAddItems()
    }

    render() {
        return (
            <motion.div className='addCouponItemsPopupContainer' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
                <div className='sendTextMessagePopupBackdrop' onClick={this.props.closeAddItems}/>
                <motion.div className='addCouponItemsContainer' id='menuContainer' initial={popupTransition.initial} animate={popupTransition.in} exit={popupTransition.out} transition={{ duration: transitionDuration }}>
                    <button className='addCouponItemsCloseButton' onClick={this.props.closeAddItems}>&#10005;</button>
                    <button className='addCouponItemsSaveButton' onClick={this.saveAndCloseHandler}>Save and Close</button>
                    <div className='addCouponItemsSectionWrapper'>
                        {this.state.itemsSelected.map((section, sectionIndex) => (
                            <div className='addCouponItemsSectionContainer'>
                                <div className='addCouponItemsSectionHeaderContainer' onClick={() => this.updateSectionSelectedHandler(sectionIndex)}>
                                    <Checkbox onMouseDown={() => this.updateSectionSelectedHandler(sectionIndex)} checked={section.items.every((value) => value === true)}/>
                                    <p className='addCouponItemsSectionHeaderText'>{this.props.menu[sectionIndex].title}</p>
                                </div>
                                {section.items.map((item, itemIndex) => (
                                    <div className='addCouponItemsItemContainer' onClick={() => this.updateItemHandler(sectionIndex, itemIndex)} style={{backgroundColor: item ? '#FCE8E8' : 'white'}}>
                                        {this.props.menu[sectionIndex].menuItem[itemIndex].image ?
                                            <img className='addCouponItemsItemImage' src={this.props.menu[sectionIndex].menuItem[itemIndex].image} alt="" />
                                        :
                                            <div className='addCouponsNoImageContainer'>
                                            </div>
                                        }
                                        <p className='addCouponItemsNameText'>{this.props.menu[sectionIndex].menuItem[itemIndex].name}</p>
                                        <Checkbox onMouseDown={() => this.updateItemHandler(sectionIndex, itemIndex)} checked={item}/>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </motion.div>
            </motion.div>
        )
    }
}
